import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

import { SessionService } from '@services/session.service';

const initialState: {
  selectedLocationId: string | null;
} = {
  selectedLocationId: null,
};

/**
 * Selected location ID for the AI Concierge section.
 * Persists across tab navigation so the location selector stays consistent.
 */
export const AiConciergeLocationStore = signalStore(
  withState(initialState),
  withMethods((store, sessionService = inject(SessionService)) => ({
    setLocationId: (locationId: string | null) => {
      patchState(store, {
        selectedLocationId: locationId ?? null,
      });
    },
    getEffectiveLocationId: (
      locationIds: string[],
      currentStored: string | null,
    ): string | null => {
      if (!locationIds.length) return null;
      if (currentStored && locationIds.includes(currentStored)) {
        return currentStored;
      }
      const sessionId = sessionService.locationId();
      if (sessionId && locationIds.includes(sessionId)) return sessionId;
      return locationIds[0] ?? null;
    },
  })),
);
